import moment from "moment";

export function timeAgo(ts) {
  const parsedTime = typeof ts === "string" ? new Date(ts).getTime() : ts;
  if (!parsedTime || isNaN(parsedTime)) return "just now";

  const diff = Date.now() - parsedTime;
  const s = Math.floor(diff / 1000);
  if (s < 60 || diff < 0) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export function getNotifTime(n) {
  // Try to use API field 'created_at' or 'timestamp' if available
  let ts =
    ("created_at" in n ? n.created_at : undefined) ||
    ("timestamp" in n ? n.timestamp : undefined);

  // If not found, fallback to socket fields
  if (!ts) {
    if ("date" in n && "time" in n && n.date && n.time) {
      ts = `${n.date} ${n.time}`;
    } else {
      ts =
        ("time" in n ? n.time : undefined) ||
        ("date" in n ? n.date : undefined);
    }
  }

  if (!ts) return "just now";
  const dateStr = moment(ts).format("DD MMM YYYY, hh:mm A");
  return `${dateStr} • ${timeAgo(ts)}`;
}

export function getNotifTitle(n) {
  const name = n.module_name;
  if (!name) return "Alert";

  const overrides = {
    "ciso-mom": "CISO MoM",
    "sla-management": "SLA Management",
  };

  if (overrides[name.toLowerCase()]) {
    return overrides[name.toLowerCase()];
  }

  return name
    .split(/[-_]/)
    .map((word) => {
      if (["mom", "sla", "ciso", "faq", "mrm"].includes(word.toLowerCase())) {
        return word === "mom" ? "MoM" : word.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export function getNotifBody(n) {
  return n.msg || "";
}
